document.addEventListener("DOMContentLoaded", function () {
  function loadWrappers() {
    let quantityWrappers = document.querySelectorAll(".input-quantity");
    quantityWrappers.forEach(function (wrapper) {
      if (wrapper.querySelector(".circle-plus")) {
        wrapper
          .querySelector(".circle-plus")
          .addEventListener("click", async function () {
            let inputselector = this.closest(".input-quantity").querySelector(
              "input.variant-quantity "
            );
            let key = inputselector.dataset.key;
            let quantity = parseInt(inputselector.value) + 1;
            if (!(quantity > parseInt(inputselector.max))) {
              wrapper.classList.add("is-loading");
              let response = await theme.cart.changeItem(key, quantity);
              response = JSON.parse(response);
              if (response.token) {
                fetchNewTempCart(response);
              }
            } else {
              let productTitle = this.closest(".cart__item-bottom")
                .parentElement.querySelector(
                  ".cart__item-top .cart__item-title"
                )
                .textContent.trim();
              alert(`You can't add more ${productTitle} to the cart.`);
            }
          });
      }
      if (wrapper.querySelector(".circle-minus")) {
        wrapper
          .querySelector(".circle-minus")
          .addEventListener("click", async function () {
            let inputselector = this.closest(".input-quantity").querySelector(
              "input.variant-quantity "
            );
            let key = inputselector.dataset.key;
            let quantity = parseInt(inputselector.value) - 1;
            if (quantity >= 0) {
              wrapper.classList.add("is-loading");
              let response = await theme.cart.changeItem(key, quantity);
              response = JSON.parse(response);
              if (response.token) {
                fetchNewTempCart(response);
              }
            }
          });
      }
      if (wrapper.querySelector("input.variant-quantity")) {
        wrapper
          .querySelector("input.variant-quantity")
          .addEventListener("change", async function () {
            if (this.value != "" || this.value != 0) {
              let key = this.dataset.key;
              let quantity = parseInt(this.value);
              if (quantity > parseInt(this.max)) {
                let productTitle = this.closest(".cart__item-bottom")
                  .parentElement.querySelector(
                    ".cart__item-top .cart__item-title"
                  )
                  .textContent.trim();
                alert(`You can't add more ${productTitle} to the cart.`);
                this.value = quantity;
              } else if (quantity >= 0) {
                wrapper.classList.add("is-loading");
                let response = await theme.cart.changeItem(key, quantity);
                response = JSON.parse(response);
                if (response.token) {
                  fetchNewTempCart(response);
                }
              }
            }
          });
      }
    });
  }

  function fetchNewTempCart(response) {
    $.ajax({
      url: "/cart?view=ajax", // Replace with the URL you want to fetch
      type: "GET",
      success: function (data) {
        document.querySelector(".cart__page [data-products]").innerHTML = "";
        document.querySelector(".cart__page [data-products]").innerHTML = data;
        document.querySelectorAll("img").forEach((img) => {
          img.classList.remove("image-element");
        });
        let subTotal = theme.Currency.formatMoney(
          response.items_subtotal_price,
          theme.settings.moneyFormat
        );
        document.querySelector(
          ".cart__page .cart__item-sub  [data-subtotal]"
        ).textContent = subTotal;
        loadWrappers();
      },
      error: function (xhr, status, error) {
        console.error("Error fetching the page:", error);
      },
    });
  }

  console.log(location.href);
  if (location.href == "https://www.clothingsupplier.com/cart") {
    debugger;
    loadWrappers();
  }
});
